import { Navigate, useLocation } from "react-router-dom";
import { useSSO } from "../context/SSO";
import Loader from "../components/Feedback/Loader";

const PrivateRoute = ({ children }) => {
  let location = useLocation();
  let auth = useSSO();

  // Mostra loader apenas se ainda está carregando a autenticação
  if (auth?.isAuthLoading) {
    return <Loader />;
  }

  // Se não está autenticado, redireciona para login
  if (!auth?.authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se não tem dados do usuário, redireciona para login
  if (!auth?.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redireciona da raiz/login para a rota apropriada baseado na role
  if (location.pathname === "/" || location.pathname === "/login") {
    const roles = auth?.user?.user?.roles || [];
    const hasMasterRole = roles.some(role => role.name === 'MASTER');
    const hasAdminCompanyRole = roles.some(role => role.name === 'RESPONSAVEL');
    
    if (hasMasterRole) {
      return <Navigate to="/registration" state={{ from: location }} replace />;
    } else if (hasAdminCompanyRole) {
      return <Navigate to="/survey-analysis" state={{ from: location }} replace />;
    } else {
      // Sem role válida, faz logout
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }

  return children;
};

export default PrivateRoute;
